const PIXEL_ID = '315698361132548'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  if (typeof window === 'undefined') return

  try {
    if (!window.fbq) {
      const n: any = (window.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      window._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
    }

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    window.fbq('init', PIXEL_ID)
    initialized = true
  } catch (e) {
    console.warn('Meta Pixel init error:', e)
  }
}

export function trackPageView() {
  try {
    if (window.fbq) {
      window.fbq('track', 'PageView')
    }
  } catch (e) {
    console.warn('Meta Pixel PageView error:', e)
  }
}

export function trackLead() {
  try {
    if (window.fbq) {
      window.fbq('track', 'Lead')
    }
  } catch (e) {
    console.warn('Meta Pixel Lead error:', e)
  }
}
